import styled from 'styled-components';

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;

  & > .accordion {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;

    & > .card:not(:first-of-type):not(:last-of-type) {
      border-bottom: 1px solid #0000FF;
      border-radius: 4px;
    }

    & > .card {
      width: 100%;
      border: 1px solid #0000FF;
      border-radius: 4px;

      .card-header {
        background-color: white;
        border: none;
        padding: 13px 25px;
        color: #0000FF;
        font-size: 1rem;
        line-height: 1.2rem;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        & svg {
          font-size: 1.5rem;
          margin-left: 10px;
        }

        & span {
          flex: 1;
        }
      }

      .card-body {
        padding: 13px 25px;
        color: #0000FF;
        font-size: 0.9rem;
        line-height: 1.2rem;
        font-weight: 300;

        & a {
          text-decoration: underline;
          color: #0000FF;
        }

        & b {
          font-weight: bold;
        }
      }
    }
  }
`;

export const AccordionHeader = styled.div`
  width: 100%;
  border-bottom: 1px dashed #0000FF;

  p {
    max-width: 318px;
    width: 100%;
    font-size: 16px;
    line-height: 22px;
    color: #0000FF;
  }
`;
